import { supabase } from '@/lib/supabase';

// ============================================================
// Journalisation centralisée de l'usage IA.
//
// Chaque appel IA (génération de thème, conversion, remplissage
// produit, etc.) enregistre ici ses tokens, sa durée et surtout
// l'utilisateur à l'origine de la requête. Le superadmin peut
// ainsi voir, dans « Usage IA & coûts », combien chaque compte
// consomme réellement en IA.
// ============================================================

export interface AiUsageEntry {
  provider: string;
  model: string;
  endpoint?: string;
  requestTokens?: number;
  responseTokens?: number;
  durationMs?: number;
  status?: 'success' | 'error';
  userId?: number | null;
}

/** Enregistre un appel IA (best-effort : n'échoue jamais l'appelant). */
export async function logAiUsage(entry: AiUsageEntry): Promise<void> {
  try {
    await supabase.from('zifek_api_logs').insert({
      provider: entry.provider,
      model: entry.model,
      endpoint: entry.endpoint || '',
      request_tokens: entry.requestTokens || 0,
      response_tokens: entry.responseTokens || 0,
      duration_ms: entry.durationMs || 0,
      status: entry.status || 'success',
      user_id: entry.userId ?? null,
    });
  } catch {
    // La journalisation ne doit jamais bloquer une fonctionnalité.
  }
}

/** Convertit l'objet `usage` renvoyé par les API OpenAI-compatibles. */
export function readUsage(usage: unknown): { requestTokens: number; responseTokens: number } {
  const u = (usage || {}) as Record<string, number>;
  return {
    requestTokens: u.prompt_tokens || u.input_tokens || 0,
    responseTokens: u.completion_tokens || u.output_tokens || 0,
  };
}